<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>Pointage</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="accent">
    </mat-progress-bar>
    <form class="edit-form" [formGroup]="editForm" (submit)="onSubmit()" *ngIf="editForm">

      <app-autocomplete class="driver-field" [control]="getControl('driver')" [list]="drivers"
        label="timeTracking.form.driver.label" errorMsg="timeTracking.form.driver.errorMessage">
      </app-autocomplete>

      <mat-form-field>
        <mat-label>Mois et année</mat-label>
        <input matInput [matDatepicker]="dp" formControlName="date">
        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
        <mat-datepicker #dp startView="multi-year" (yearSelected)="chosenYearHandler($event)"
          (monthSelected)="chosenMonthHandler($event, dp)" panelClass="example-month-picker">
        </mat-datepicker>
        <mat-error>La date est requise.</mat-error>
      </mat-form-field>

      <section class="actions">
        <button mat-raised-button *ngIf="!isLoading" type="submit" color="primary" [disabled]="editForm.invalid">
          Exporter
        </button>
        <mat-spinner *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>
      </section>
    </form>

    <section class="sectionTable">
      <h3>Historique
        <button mat-icon-button color="primary" *ngIf="!filterForm.pristine" matTooltip="Effacer les filtres"
          (click)="clearFilters()">
          <mat-icon>
            clear
          </mat-icon>
        </button>
      </h3>

      <mat-table [hidden]="!history || isLoading" [dataSource]="dataSource" class="mat-elevation-z2 statusTable" matSort
        (matSortChange)="onSortChanged($event)" [formGroup]="filterForm">
        <ng-container matColumnDef="user">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              Chauffeur
              <mat-select class="type-filter" formControlName="user" (click)="$event.stopPropagation()"
                (selectionChange)="onFilter()" placeholder="Filtre">
                <mat-option *ngFor="let user of drivers" [value]="user.id">
                  {{user.username}}
                </mat-option>
              </mat-select>
              <!-- <div class="autocompleteFilter">
                <app-autocomplete *ngIf="!isLoadingFilterForm && drivers" [control]="filterForm.get('user')"
                  [list]="drivers" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation(); onFilter()">
                </app-autocomplete>
              </div> -->
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let history"> {{ history.timeRecord.user.username }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              Type
              <mat-select class="type-filter" formControlName="type" (click)="$event.stopPropagation()"
                (selectionChange)="filterEnter($event, 'type')" placeholder="Filtre">
                <mat-option *ngFor="let type of allTypes" [value]="type.value">
                  {{type.name}}
                </mat-option>
              </mat-select>
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let history"> {{showTypeText(history.timeRecord.type) | translate}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="createdOn">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              Modifié le
              <mat-form-field>
                <input matInput formControlName="createdOn" [matDatepicker]="createdOnPicker"
                  (click)="$event.stopPropagation(); createdOnPicker.open()" (focus)="createdOnPicker.open()"
                  (dateChange)="filterEnter('truc', 'createdOn')">
                <mat-datepicker-toggle matSuffix [for]="createdOnPicker"></mat-datepicker-toggle>
                <mat-datepicker #createdOnPicker></mat-datepicker>
              </mat-form-field>
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let history"> {{history.createdOn | amDateFormat: 'DD/MM/YYYY HH:mm'}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="comment">
          <mat-header-cell *matHeaderCellDef>
            Commentaire
          </mat-header-cell>
          <mat-cell *matCellDef="let history"> {{history.comment}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="date">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              Date de pointage
              <mat-form-field>
                <input matInput formControlName="date" [matDatepicker]="datePicker"
                  (click)="$event.stopPropagation(); datePicker.open()" (focus)="datePicker.open()"
                  (dateChange)="filterEnter('truc', 'date')">
                <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                <mat-datepicker #datePicker></mat-datepicker>
              </mat-form-field>
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let history"> {{history.timeRecord.date | amDateFormat: 'DD/MM/YYYY HH:mm'}}
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
      <mat-paginator [hidden]="!history || isLoading" *ngIf="pagination" [pageSize]="pagination.pageSize"
        [length]="pagination.totalRecords" [pageIndex]="pagination.pageNumber - 1" (page)="onPageChanged($event)"
        showFirstLastButtons></mat-paginator>
      <p *ngIf="!history">Il n'y a pas d'historique.</p>
    </section>
  </mat-card-content>
</mat-card>